import React, { useState } from 'react';

const FollowButton = (props) => {
    const { isFollowed, onClickCallback } = props;

    return isFollowed ? (
        <button
            className="btn btn-secondary follow-button"
            type="button"
            onClick={onClickCallback}
        >
            Following
        </button>
    ) : (
        <button
            className="btn follow-button follow-button-color"
            type="button"
            onClick={onClickCallback}
        >
            Follow
        </button>
    );
};

export default FollowButton;
